export function deepFindObjectValueByPath (obj, path) {
  let paths = path.split('.')
  let current = obj
  let i

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined || current[paths[i]] === null) {
      return undefined
    } else {
      current = current[paths[i]]
    }
  }
  return current
}
